import { IConnectionDrawingOptions } from '..';
import {
	ProjectState,
	ActionDescriptorState,
	ConditionState,
	ChangeSet,
	ChangeSetEntityChangeType,
} from '@elyx-code/project-logic-tree';
import { connectPassthroughCallable } from './utils';

export function createConditionFromActionDescriptor(
	from: ActionDescriptorState,
	connectionOptions: IConnectionDrawingOptions,
	project: ProjectState,
	changeSet: ChangeSet
): ConditionState {
	// Create a new function-declaration that implements the abstract entity
	const newCondition = from.implementAsCondition(changeSet);

	changeSet.add(newCondition, ChangeSetEntityChangeType.Added);

	connectPassthroughCallable(newCondition, connectionOptions, project, changeSet);

	return newCondition;
}
